// extracted by mini-css-extract-plugin
export default {"enabled":"PageIcon_enabled__2n-5n","disabled":"PageIcon_disabled__s6Aaf"};